/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonSharedMaritalStatusDropdownQueryResponse,
  GetApiV1PersonSharedMaritalStatusDropdown401,
  GetApiV1PersonSharedMaritalStatusDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedMaritalStatusDropdown.ts";

function getGetApiV1PersonSharedMaritalStatusDropdownUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/person/shared/marital-status-dropdown` as const,
  };
  return res;
}

/**
 * @description Retorna todas as opções do enumerador EMartialStatus para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de estados civis para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/marital-status-dropdown}
 */
export async function getApiV1PersonSharedMaritalStatusDropdown(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonSharedMaritalStatusDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedMaritalStatusDropdown401
      | GetApiV1PersonSharedMaritalStatusDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonSharedMaritalStatusDropdownUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
